import * as React from 'react'
import * as css from './Header.module.css'
import { GlobalContext } from '../Store'
import { isMobile } from 'react-device-detect'
import { Link } from 'gatsby'
import HeaderLinks from './HeaderLinks'
import ToggleMobileMenu from './ToggleMobileMenu'
import logo from 'assets/fastech-logo-white.svg'
import clsx from 'clsx'

export default function Header({ transparent }) {
	const { mobileMenuState, set$headerMenu } = React.useContext(GlobalContext)

	const inView = transparent?.inView

	function onMouseLeave() {
		!isMobile && set$headerMenu(false)
	}

	return (
		<header
			className={clsx(
				css.root,
				'sticky inset-x-0 top-0 z-[99] text-white transition-colors',
				inView
					? ['bg-transparent hover:fixed hover:bg-suede-black', css.transparent]
					: 'bg-suede-black',
				mobileMenuState && ['!bg-suede-black', css.mobile],
			)}
			style={{ position: !!transparent ? 'fixed' : 'sticky' }}
		>
			{/* eslint-disable jsx-a11y/no-static-element-interactions */}
			<div
				className="mx-auto grid max-w-screen-xl items-center gap-4 p-4 outline-none md:grid-cols-[1fr,auto,1fr] <md:grid-cols-[auto,1fr,auto]"
				onMouseLeave={onMouseLeave}
			>
				<div>
					<Link to="/">
						<img
							className={clsx(
								css.logo,
								'w-[150px] min-w-[100px] transition-[filter]',
							)}
							src={logo}
							alt="FASTECH logo"
							width={170}
							height={26}
							loading="eager"
						/>
					</Link>
				</div>

				<HeaderLinks />

				<div className={clsx(css.contact, 'text-right')}>
					<Link
						to="/contact"
						className="action transtion-[text-shadow] font-bold <md:bg-none <md:p-0"
					>
						Contact
					</Link>
				</div>

				<ToggleMobileMenu transparent={inView} />
			</div>
		</header>
	)
}
